import React, { Component } from 'react';
import ActivityLoader from '../../Components/Common/ActivityLoader';
import AlertError from '../../Components/Common/AlertError';
import AlertSuccess from '../../Components/Common/AlertSuccess';
import CallOut from '../../Components/Common/CallOut';
import TextInput from '../../Components/Common/TextInput';
import TopBar from '../../Components/Common/TopBar';
import PageContainer from '../../Components/Headings/PageContainer';
import PageTitle from '../../Components/Headings/PageTitle';
import ajaxLedger from '../../remote/ajaxLedger';
import ajaxPayee from '../../remote/ajaxPayee';


class ImportVendorsPage extends Component {

    state={
        info:'',
        loading:false,
        fileName:'',
        actualCsvFile:''
    }


   
    onChangeFile = (event) => {
        this.setState({
         fileName:event.target.value
        })
         let files=event.target.files;
         let reader=new FileReader();
         reader.readAsDataURL(files[0]);
         reader.onload=(e)=>{
             this.setState({
                actualCsvFile:{file:  e.target.result}
             })
         }
         
       }
    

       onConfirm = async (event) => {
        event.preventDefault();
        const {fileName, actualCsvFile}=this.state;
        if (fileName.length > 0) {
            this.setState({
                loading: true
            })

            const server_response=await ajaxPayee.importPayees(actualCsvFile);
            this.setState({
                loading: false
            })
            if(server_response.status==="OK")
            {
                this.setState({
                    info: <AlertSuccess message={server_response.message} />,
                    fileName:'',
                    actualCsvFile:''
                })
            }else{
                this.setState({
                    info: <AlertError message={server_response.message} />
                })
            }

        } else {
            this.setState({
                info: <AlertError message={"Select CSV file and try again"} />
            })
        }
    }


  
    render() {
        return (
            <PageContainer title="Import Vendors">
            <div className="row">
                <div className="col-md-12">
                    <CallOut title="Note" description="The vendor records must be from a csv file arranged in the format: Vendor Name, Description, Address, Phone Number, Email"/>
                   
                    <div className="card">
                    {/* <div className="card-header"></div> */}

                    <div className="card-body">
                    
                 
                        <form className="form-horizontal" method="post" onSubmit={this.onConfirm}>
                                {this.state.info}
                                {this.state.loading && <ActivityLoader/>}

                                <TextInput
                                type="file"
                                label="Select CSV file"
                                placeholder="Select CSV file"
                                leftIcon="fa fa-file"
                                onChange={this.onChangeFile} 
                                required
                                />

                           
                            <div className="row">&nbsp;</div>
                           
                          
        

                            <div className="row">&nbsp;</div>
                            
                            <div className="modal-footer no-border">
                                <div className="col-md-7">
                                {!this.state.loading && <button type="submit" className="btn btn-primary">Import</button>}
                                </div>
                            </div>

                        </form> 

   

                    </div>





                    </div>

                </div>


                {/** Body ends */}

                </div>
           </PageContainer>
        );
    }
}

export default ImportVendorsPage;